export default __webpack_public_path__ + "static/media/iconUIUX.6d9922ae.svg";